import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { GlobalService } from './global.service';


@Injectable({
  providedIn: 'root'
})
export class UploadFileService {
  
  constructor(
    private globalService: GlobalService,
    private http: HttpClient) { }

  uploadFile(token, folder, formData){
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': token
      })
    };
    return this.http.post<any>(this.globalService.uploadFile(folder), formData, httpOptions)
  }

  uploadCsv(token, formData){
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': token
      })
    };
    return this.http.post<any>(this.globalService.uploadCsvURL, formData, httpOptions)
  }

  uploadTicketFile(token, formData, id){
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': token
      })
    };
    return this.http.post<any>(this.globalService.newTicketFile(id), formData, httpOptions)
  }

  downloadPFCsv(token){
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': token
      }),
      _responseType: "blob",
      get responseType() {
        return this._responseType;
      },
      set responseType(value) {
        this._responseType = value;
      },
    };

    return this.http.get<any>(this.globalService.downloadPFCsvURL, httpOptions)
  }

  downloadPGCsv(token){
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': token
      }),
      _responseType: "blob",
      get responseType() {
        return this._responseType;
      },
      set responseType(value) {
        this._responseType = value;
      },
    };

    return this.http.get<any>(this.globalService.downloadPGCsvURL, httpOptions)
  }
  
}
